import { render, staticRenderFns } from "./ExemptionRateColumn.vue?vue&type=template&id=531ce439&scoped=true&"
import script from "./ExemptionRateColumn.vue?vue&type=script&lang=js&"
export * from "./ExemptionRateColumn.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionRateColumn.vue?vue&type=style&index=0&id=531ce439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ce439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531ce439')) {
      api.createRecord('531ce439', component.options)
    } else {
      api.reload('531ce439', component.options)
    }
    module.hot.accept("./ExemptionRateColumn.vue?vue&type=template&id=531ce439&scoped=true&", function () {
      api.rerender('531ce439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/ExemptionRateColumn.vue"
export default component.exports